import React, { useCallback, useContext } from 'react';
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from '@mui/material';

import { IItem, IItemKey } from 'api/catalog/models';
import { useItemAttributes, useItemRendering } from 'hooks';
import { DetailViewContext } from 'providers';

interface IProps {
  item: IItem;
}

const GenericItemInformation = ({ item }: IProps) => {
  const { visibleFields = [] } = useContext(DetailViewContext);
  const { getLabel } = useItemAttributes();
  const { getCommonAttributeRender } = useItemRendering();

  const renderCell = useCallback(
    (key: IItemKey) => {
      switch (key) {
        default:
          return getCommonAttributeRender(item, key);
      }
    },
    [getCommonAttributeRender, item]
  );

  return (
    <TableContainer>
      <Table size='small'>
        <TableBody>
          {visibleFields.map((key) => (
            <TableRow hover key={key}>
              <TableCell sx={{ fontWeight: 'bold' }}>{getLabel(key)}</TableCell>
              <TableCell>{renderCell(key)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GenericItemInformation;
